<template><div><h1>样式冗余</h1>
<h2>调试时</h2>
<p>调试时如果你审查元素样式发现有多个重复样式是正常的，因为不同组件可能引用了同样的less源码，而调试时是直接把不同组件样式用<code>&lt;style&gt;</code>标签插入页面。</p>
<h2>打包时</h2>
<p>确保在<code>vux-loader</code>里使用<code>duplicate-style</code>插件来实现对构建css进行冗余压缩。</p>
<h2>异步路由的样式</h2>
<p>一般情况下，打包后异步路由的样式会使用 js 的方式插入到页面，有时候这并不是我们所要的。可以通过配置 <code>ExtractTextPlugin</code> 插件的 <code>allChunks</code> 实现样式抽离。</p>
<pre class="hljs"><code><span class="hljs-keyword">new</span> ExtractTextPlugin({
  <span class="hljs-attr">filename</span>: utils.assetsPath(<span class="hljs-string">'css/[name].[contenthash].css'</span>),
  <span class="hljs-attr">allChunks</span>: <span class="hljs-literal">true</span>
})
</code></pre>
</div></template><script>
export default {
  head: {"title":"样式冗余 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// dupicate-style-45.vue?935334c6